import $ from 'jquery';
import {Swiper, Autoplay, Navigation} from 'swiper/js/swiper.esm.js';
Swiper.use([Autoplay, Navigation]);

const categorySlider = new Swiper('.swiper-category-slider', {
    watchOverflow: true,
    autoHeight: true,
    spaceBetween: 15,
    slidesPerView: 1,
    cssMode: true,
    breakpoints: {
        400: {
            slidesPerView: 2,
        },
        1050: {
            slidesPerView: 3
        },
        1350: {
            slidesPerView: 4
        },
        1650: {
            slidesPerView: 5
        },
        1850: {
            slidesPerView: 6
        }
    },
    navigation: {
        nextEl: ".category-swiper-button-next",
        prevEl: ".category-swiper-button-prev",
    }
});
